import Vue from 'vue'
import Vuex from 'vuex'
import * as types from './mutation-types'
import Cardapio from '../services/cardapio'
import Swal from "sweetalert2";
import createPersistedState from 'vuex-persistedstate';
import SecureLS from 'secure-ls';
var ls = new SecureLS({ encodingType: 'aes' });

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// ==========================
// STATE
// ==========================
const state = {
  nome: "",
  logado: false,
  estoque: false,
  funcionamento: "",
  telefone: "",
  contrato: "vueX" + localStorage.getItem('contrato'),
  pagamentoPix: null,
  added: [],
  addedadi: [],
  all: [], // Produtos do cardápio
  adi: [],
  produtosCarregados: [],
  produtosQuantidadeCarregada: 5,
}

// ==========================
// GETTERS
// ==========================
const getters = {
  retornaNome: state => state.nome,
  retornaLogado: state => state.logado,
  retornaEstoque: state => state.estoque,
  getPagamentoPix: state => state.pagamentoPix,
  allAdicionais: state => state.adi,
  allProducts: state => state.all,
  getNumberOfProducts: state => state.produtosCarregados,
  getProdutosCarregados: state => state.produtosQuantidadeCarregada,
  cartProducts: state => state.added,
}

// ==========================
// ACTIONS
// ==========================
const actions = {
  addToCart({ commit }, { product, adicionaispergunta, obs }) {
    const dados = {
      produto: product,
      adicionais: adicionaispergunta,
      observacao: obs
    }
    commit(types.ADD_TO_CART, { dados })
  },

  async fetchProducts({ commit }) {
    try {
      const resposta = await Cardapio.listar()
      if (resposta && resposta.data) {
        commit(types.FETCH_PRODUCTS, resposta.data)
      } else {
        console.warn("⚠️ Nenhum produto retornado pela API")
      }
    } catch (error) {
      console.error("❌ Erro ao buscar produtos:", error)
    }
  },

  async fetchProductsLimited({ commit }) {
    try {
      const resposta = await Cardapio.listar()
      commit(types.FETCH_PRODUCTS_LIMIT, resposta.data)
    } catch (error) {
      console.error("❌ Erro ao buscar produtos limitados:", error)
    }
  },

  removeFromCart({ commit }, index) {
    commit(types.REMOVE_FROM_CART, { index })
  },

  menosqtd({ commit }, index) {
    commit(types.DECREMENTA_QUANTIDADE, { index })
  },

  somarqtd({ commit }, index) {
    commit(types.INCREMENTA_QUANTIDADE, { index })
  },

  removeFromCartAd({ commit }, adicionaispergunta) {
    commit(types.REMOVE_FROM_CART_AD, {
      cd: adicionaispergunta.cd
    })
  }
}

// ==========================
// MUTATIONS
// ==========================
const mutations = {
  setFuncionamento(state, funcionamento) {
    state.funcionamento = funcionamento;
  },
  setLogado(state, logado) {
    state.logado = logado;
  },
  setNome(state, nome) {
    state.nome = nome;
  },
  setTelefone(state, telefone) {
    state.telefone = telefone;
  },
  setEstoque(state, estoque) {
    state.estoque = estoque;
  },
  setPagamentoPix(state, pagamento) {
    state.pagamentoPix = pagamento;
  },
  setZera(state, zerado) {
    state.added = zerado;
    state.all = zerado;
    state.adi = zerado;
    state.addedadi = zerado;
  },

  // ======================
  // CARRINHO
  // ======================
  [types.ADD_TO_CART](state, dados) {
    const cd = dados.dados.produto.cd;
    const nm = dados.dados.produto.nm;
    const classe = dados.dados.produto.classe;
    const ingredientes = dados.dados.produto.ingredientes;
    const adicionaispergunta = dados.dados.adicionais;
    const obs = dados.dados.observacao;
    const peso = dados.dados.produto.peso;
    const unitario = dados.dados.produto.unitario;
    const agendamento = dados.dados.produto.agendamento;

    const record = state.added.find(p => p.cd === cd);

    let valortotaladicional = 0;
    adicionaispergunta.forEach((item, index) => {
      if (item.tipo === "PIZZA" && index === 0) {
        valortotaladicional += parseFloat(item.vl);
      } else {
        valortotaladicional = (parseFloat(valortotaladicional) + parseInt(item.qtd) * parseFloat(item.vl)).toFixed(2);
      }
    });

    const vl = (parseFloat(dados.dados.produto.vl) + parseFloat(valortotaladicional)).toFixed(2);

    const novoItem = {
      cd,
      nm,
      vl,
      classe,
      ingredientes,
      adicionaispergunta,
      obs,
      quantity: 1,
      peso,
      unitario,
      agendamento
    };

    if (!record) {
      state.added.push(novoItem);
    } else {
      state.added.push(novoItem);
    }
  },

  // ======================
  // PRODUTOS
  // ======================
  [types.FETCH_PRODUCTS](state, products) {
    state.all = products;
  },

  [types.FETCH_PRODUCTS_LIMIT](state, products) {
    state.produtosCarregados = products;
  },

  // ======================
  // CARRINHO - REMOVER E ALTERAR QTD
  // ======================
  [types.REMOVE_FROM_CART](state, { index }) {
    state.added.splice(index, 1);
  },

  [types.DECREMENTA_QUANTIDADE](state, { index }) {
    if (state.added[index].quantity >= 2) {
      state.added[index].quantity -= 1;
    } else {
      Swal.fire({
        title: "Obrigatório ter pelo menos um item desse produto.",
        confirmButtonColor: "#000000",
      });
    }
  },

  [types.INCREMENTA_QUANTIDADE](state, { index }) {
    state.added[index].quantity += 1;
  },
}

// ==========================
// EXPORTAÇÃO FINAL
// ==========================
export default new Vuex.Store({
  state,
  plugins: [
    createPersistedState({
      key: state.contrato,
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key),
      },
    }),
  ],
  strict: debug,
  getters,
  actions,
  mutations,
})
